import { auth, db, storage } from '../config/firebase';

export const testFirebaseConnection = async () => {
  console.log('Testing Firebase connection...');
  
  try {
    // Test Authentication
    console.log('Auth instance:', auth ? '✓ Connected' : '✗ Failed');
    
    // Test Firestore
    console.log('Firestore instance:', db ? '✓ Connected' : '✗ Failed');
    
    // Test Storage
    console.log('Storage instance:', storage ? '✓ Connected' : '✗ Failed');
    
    // Test app configuration
    console.log('Project ID:', auth.app.options.projectId);
    console.log('Auth Domain:', auth.app.options.authDomain);
    
    return {
      auth: !!auth,
      firestore: !!db,
      storage: !!storage,
      projectId: auth.app.options.projectId
    };
    
  } catch (error) {
    console.error('Firebase connection test failed:', error);
    return {
      auth: false,
      firestore: false,
      storage: false,
      error: error
    };
  }
};

// Helper function to check Firebase services status
export const getFirebaseStatus = () => {
  return {
    configured: !!(auth && db && storage),
    projectId: auth?.app?.options?.projectId || 'Not configured',
    authDomain: auth?.app?.options?.authDomain || 'Not configured',
    services: {
      auth: !!auth,
      firestore: !!db,
      storage: !!storage
    }
  };
};